import PropTypes from "prop-types";

import AppliedTagItem from "./AppliedTagItem";

const PartlyAppliedTagItem = ({ tag, selectedCount, isBusy, onRemove }) => (
  <AppliedTagItem tag={tag} isBusy={isBusy} onRemove={onRemove}>
    <span
      className="tw:text-xs tw:text-muted-foreground tw:tabular-nums"
      aria-label={`On ${tag.count} of ${selectedCount} selected`}
    >
      {tag.count}/{selectedCount}
    </span>
  </AppliedTagItem>
);

PartlyAppliedTagItem.propTypes = {
  tag: PropTypes.object.isRequired,
  selectedCount: PropTypes.number.isRequired,
  isBusy: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
};

export default PartlyAppliedTagItem;
